<template>
  <Modal
      v-model="_value"
      width="400"
      title="客户拒绝服务"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">
    <Form v-if="orderList.length == 0" ref="renewalOrderForm" :model="renewalOrder">
      <FormItem prop="registrationNum" label="车牌号">
        <label style="display: inline-block; width: 100px;">{{renewalOrder.positioningDeviceInfo.vehicleInfo != null ? renewalOrder.positioningDeviceInfo.vehicleInfo.registrationNum : renewalOrder.positioningDeviceInfo.vehicleInfo.vin}}</label>
      </FormItem>
      <FormItem prop="remark" label="备注">
          <Input v-model="renewalOrder.remark"
                 type="textarea"
                 placeholder="请输入备注"></Input>
      </FormItem>
    </Form>

      <Form v-else ref="renewalOrderForm" :model="renewalOrder">
        <div v-for="item in orderList">
          <FormItem prop="registrationNum" label="车牌号">
            <label style="display: inline-block; width: 100px;">{{item.positioningDeviceInfo.vehicleInfo != null ? item.positioningDeviceInfo.vehicleInfo.registrationNum : item.positioningDeviceInfo.vehicleInfo.vin}}</label>
          </FormItem>
        </div>
        <FormItem prop="remark" label="备注">
            <Input v-model="renewalOrder.remark"
                   type="textarea"
                   placeholder="请输入备注"></Input>
        </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'renewalorderrefuseservicemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      //  订单详细
      renewalOrder: {
        id: null,
        totalAmount: 0,
        lastTotalAmount: null,
        oldServiceDatetime: null,
        serviceDatetime: null,
        businessUserId: null,
        businessUser: null,
        receptUserId: null,
        receptUser: null,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: {

          },
          vehicleInfo: {
            customName: null,
            registrationNum: null,
            registrationColor: null,
            vin: null,
            bodyColor: null,
            vehicleType: {
              id: null,
              name: null
            },
            vehicleBrand: {
              id: null,
              name: null
            },
            engineNum: null,
            vehicleLicenseNum: null,
            unladenMass: null,
            approvedLoad: null,
            vehicleOwnerInfoId: null,
            servicePassword: null,
            vehicleLicenseDistributeDatetime: null,
            vehicleLicenseReigsterDatetime: null,
            remark: null,
            certificateNum: null,
            certificateDistributeDatetime: null,
            vehicleModel: {
              id: null,
              name: null
            },
            chassisModel: null,
            chassisId: null,
            chassisCertificateNum: null,
            engineModel: null,
            energyType: null,
            displacement: null,
            power: null,
            energyUsage: null,
            emissionStandard: null,
            manufacturer: null,
            outlineSizeLong: null,
            outlineSizeWidth: null,
            outlineSizeHeight: null,
            boxSizeLong: null,
            boxSizeWidth: null,
            boxSizeHeight: null,
            springPieceCount: null,
            tyreCount: null,
            tyreSpec: null,
            wheelSpanFront: null,
            wheelSpanBack: null,
            wheelBase: null,
            axisLoad: null,
            axisCount: null,
            turnType: null,
            totalMass: null,
            approvedLoadCoefficient: null,
            towMax: null,
            saddleMax: null,
            cabPeopleCount: null,
            mannedCount: null,
            speedMax: null,
            productionDatetime: null,
            certificateRemark: null,
            vehicleLicensePictureId: null,
            certificatePictureId: null,
            vehicleSrcLicensePicture1Id: null,
            vehicleSrcLicensePicture2Id: null,
            vehicleBodyPictureId: null,
            vehicleUse: null,
            attention: false,
            mliftainsuranceChannelId: null,
            mliftainsurancechannelDatetime: null,
            tiinsuranceChannelId: null,
            tiinsurancechannelDatetime: null,
            insured: null
          }
        },
        updateDatetime: null,
        remark: null,
        billType: 1,
        fileReady: null,
        salesChannelId: null,
        salesChannel: null,
        renewalOrderType: null,
        changeSim: null,
        maintainOrderId: null,
        maintainOrder: null,
        isfree: null,
        needJt808Combine: null,
        renewalNum: null,
        renewalPayOrderId: null,
        renewalPayOrder: null,
        deadlineDatetime: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null
    }
  },
  methods: {
    ...mapActions([
      'RenewalOrderServ_RefuseService'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        store.dispatch('RenewalOrderServ_BatchRefuseService', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                remark: this.renewalOrder.remark
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认拒绝服务</p>',
          onOk: () => {
            store.dispatch('RenewalOrderServ_RefuseService',
              { params: this.renewalOrder }).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.renewalOrder.id = this._initValue
        this.renewalOrder.remark = null
        this.orderIds = []

        this.orderList = this._listValue
        // console.log(this.orderList)
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
        } else {
          this.orderIds = []

          let renewalOrderId = this._initValue
          if (renewalOrderId) {
            store.dispatch('RenewalOrderServ_GetDetail', {
              params: { id: renewalOrderId }
            }).then(() => {
              this.renewalOrder = store.getters.get_RenewalOrder_GetDetailResult
              if (this.renewalOrder.serviceDatetime) {
                this.renewalOrder.serviceDatetime = new Date(this.renewalOrder.serviceDatetime)
              }
              this.renewalOrder.remark = null
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
